import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import LaptopMacIcon from '@material-ui/icons/LaptopMac';
import AccessibilityIcon from '@material-ui/icons/Accessibility';
import BugReportIcon from '@material-ui/icons/BugReport';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import './Plan.css';
import '../../App.css';
import Footer from '../Footer';
import { BugReport } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: '6px 16px',
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main,
  },
}));



export default function Plan() {
  const classes = useStyles();

  return (
      <>
    <h1 className='plan'>Plán</h1>
    <Timeline align="alternate">
      <TimelineItem>
        <TimelineOppositeContent>
          <Typography variant="body2" color="textSecondary">
            Marec - Apríl 2021
          </Typography>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot>
            < MenuBookIcon/>
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h6" component="h1">
                Úvod
            </Typography>
            <Typography>Hľadanie zdrojov, zoznamovanie sa s témov.</Typography>
          </Paper>
        </TimelineContent>
      </TimelineItem>


      <TimelineItem> 
        <TimelineOppositeContent>
          <Typography variant="body2" color="textSecondary">
            Apríl 2021
          </Typography>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot>
            <LaptopMacIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h6" component="h1">
              Návrh
            </Typography>
            <Typography> Návrh jazyka a používateľského rozhrania.</Typography>
          </Paper>
        </TimelineContent>
      </TimelineItem>

      <TimelineItem> 
        <TimelineOppositeContent>
          <Typography variant="body2" color="textSecondary">
            Apríl - Máj 2021
          </Typography>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot>
            <LaptopMacIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h6" component="h1">
              Code
            </Typography>
            <Typography>Pracovanie na prototype.</Typography>
          </Paper>
        </TimelineContent>
      </TimelineItem>

      <TimelineItem>
        <TimelineOppositeContent>
          <Typography variant="body2" color="textSecondary">
            Máj - Október 2021
          </Typography>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot>
          <LaptopMacIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h6" component="h1">
            Code 
            </Typography>
            <Typography>Implementácia príkazov TónIK.</Typography>
          </Paper>
        </TimelineContent>
      </TimelineItem>


      <TimelineItem>
        <TimelineOppositeContent>
          <Typography variant="body2" color="textSecondary">
          Oktober 2021 - Január 2022
          </Typography>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot color="primary" >
          <LaptopMacIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h6" component="h1">
            Code a Text
            </Typography>
            <Typography>Implementácia a finalizácia všetkých príkazov. Písanie textovej časti diplomovej práce.</Typography>
          </Paper>
        </TimelineContent>
      </TimelineItem>


      <TimelineItem>
        <TimelineOppositeContent>
          <Typography variant="body2" color="textSecondary">
          Oktober 2021 - Január 2022
          </Typography>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot>
          <LaptopMacIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h6" component="h1">
            Code a Text.  
            </Typography>
            <Typography>Finalizácia príkazov. Písanie textovej časti diplomovej práce.</Typography>
          </Paper>
        </TimelineContent>
      </TimelineItem>

      <TimelineItem>
        <TimelineOppositeContent>
          <Typography variant="body2" color="textSecondary">
          Február 2022
          </Typography>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot>
          <BugReportIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h6" component="h1">
            Testovanie aplikácie 1. fáza a Text
            </Typography>
            <Typography>Testovanenie aplikácie autorkou a zapracovanie nedostatov. Písanie textovej časti diplomovej práce. </Typography>
          </Paper>
        </TimelineContent>
      </TimelineItem>


      <TimelineItem>
        <TimelineOppositeContent>
          <Typography variant="body2" color="textSecondary">
           Marec 2022
          </Typography>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot>
          <BugReportIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h6" component="h1">
            Testovanie aplikácie 2. fáza a Text
            </Typography>
            <Typography>Testovanie učiteľmi nevidiach žiakov. Zapracovanie pripomienok. Písanie textovej časti diplomovej práce.</Typography>
          </Paper>
        </TimelineContent>
      </TimelineItem>


      <TimelineItem>
        <TimelineOppositeContent>
          <Typography variant="body2" color="textSecondary">
          Začiatok Apríla 2022
          </Typography>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot>
          <AccessibilityIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h6" component="h1">
            Testovanie aplikácie 3. fáza a Text
            </Typography>
            <Typography>Testovanie so žiakmi. Zapracovanie pripomienok. Finalizácia textovej časti diplomovej práce.</Typography>
          </Paper>
        </TimelineContent>
      </TimelineItem>


      <TimelineItem >
        <TimelineOppositeContent>
          <Typography variant="body2" color="textSecondary">
          Koniec Apríla 2022
          </Typography>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot>
          <CheckCircleOutlineIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h6" component="h1">
            Odovzdávanie
            </Typography>
            <Typography>Finálna verzia.</Typography>
          </Paper>
        </TimelineContent>
      </TimelineItem>
    </Timeline>
    <Footer />
    </>
  );
}
